var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box mt-10" },
    [
      _c(
        "md-card",
        [
          _c(
            "md-card-expand",
            [
              _c(
                "md-card-actions",
                { attrs: { "md-alignment": "space-between" } },
                [
                  _c(
                    "md-card-expand-trigger",
                    [
                      _c(
                        "md-button",
                        { staticClass: "community-expand-button m-left-5" },
                        [_c("div", [_vm._v("Recruiting")])]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "md-card-expand-content",
                [
                  _c("md-card-content", { staticClass: "rules card-content" }, [
                    _c("div", [
                      _c(
                        "form",
                        {
                          staticClass: "form-recruiting",
                          attrs: {
                            autocomplete: "off",
                            "data-vv-scope": "form-recruiting"
                          },
                          on: {
                            submit: function($event) {
                              $event.preventDefault()
                              return _vm.save("form-recruiting")
                            },
                            change: function($event) {
                              _vm.saveText = "Save"
                            }
                          }
                        },
                        [
                          _c("section", { staticClass: "recruiting-section" }, [
                            _c(
                              "h4",
                              { staticClass: "recruiting-section__title" },
                              [_vm._v("Module Activation")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "recruiting-check-row" },
                              [
                                _c(
                                  "md-checkbox",
                                  {
                                    staticClass: "approval-request",
                                    model: {
                                      value: _vm.config.moduleEnabled,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.config,
                                          "moduleEnabled",
                                          $$v
                                        )
                                      },
                                      expression: "config.moduleEnabled"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                    Recruiting Module\n                  "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("p", { staticClass: "recruiting-helper" }, [
                                  _vm._v(
                                    "\n                    When unchecked, Opportunities are not shown in the Dashboard.\n                  "
                                  )
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.config.moduleEnabled
                              ? _c(
                                  "div",
                                  { staticClass: "recruiting-field-row" },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "recruiting-field-row__label"
                                      },
                                      [
                                        _vm._v(
                                          "\n                    Job Posting URL (auto-generated):\n                  "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "md-field",
                                      { staticClass: "create-rule" },
                                      [
                                        _c("md-input", {
                                          attrs: {
                                            value: _vm.wizardURLDisplay,
                                            readonly: "",
                                            name: "jobPostingUrl",
                                            placeholder:
                                              "URL will be generated when module is enabled"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      { staticClass: "recruiting-helper" },
                                      [
                                        _vm._v(
                                          "\n                    Integrated into the Program Page like Channels URLs.\n                  "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.config.moduleEnabled
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "recruiting-field-row recruiting-learn-more"
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "recruiting-field-row__label"
                                      },
                                      [
                                        _vm._v(
                                          "\n                    Recruiting Program Page:\n                  "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "md-field",
                                      { staticClass: "create-rule" },
                                      [
                                        _c("md-input", {
                                          attrs: {
                                            name: "learnMoreURL",
                                            placeholder:
                                              "https://example.com/careers/learn-more"
                                          },
                                          on: {
                                            input: function($event) {
                                              _vm.saveText = "Save"
                                            }
                                          },
                                          model: {
                                            value: _vm.config.learnMoreURL,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.config,
                                                "learnMoreURL",
                                                $$v
                                              )
                                            },
                                            expression: "config.learnMoreURL"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      { staticClass: "recruiting-helper" },
                                      [
                                        _vm._v(
                                          '\n                    Destination for the "Learn More" link at the bottom of\n                    the recruiting wizard.\n                  '
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _vm.config.moduleEnabled
                            ? [
                                _c(
                                  "section",
                                  { staticClass: "recruiting-section" },
                                  [
                                    _c(
                                      "h4",
                                      {
                                        staticClass: "recruiting-section__title"
                                      },
                                      [_vm._v("Administrators")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      {
                                        staticClass: "recruiting-section__desc"
                                      },
                                      [
                                        _vm._v(
                                          "\n                    Assign individual members from the community for each\n                    role. Selection pattern mirrors Requests (existing\n                    member pool).\n                  "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(_vm.adminRoles, function(role) {
                                      return _c(
                                        "div",
                                        {
                                          key: role.key,
                                          staticClass: "recruiting-field-row"
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "recruiting-field-row__label"
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(role.label) +
                                                  "\n                    "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "md-field",
                                            { staticClass: "create-rule" },
                                            [
                                              _c("md-input", {
                                                attrs: {
                                                  name: "admin_" + role.key,
                                                  placeholder: role.placeholder
                                                },
                                                model: {
                                                  value:
                                                    _vm.config.administrators[
                                                      role.key
                                                    ],
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.config.administrators,
                                                      role.key,
                                                      typeof $$v === "string"
                                                        ? $$v.trim()
                                                        : $$v
                                                    )
                                                  },
                                                  expression:
                                                    "config.administrators[role.key]"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            {
                                              staticClass: "recruiting-helper"
                                            },
                                            [_vm._v(_vm._s(role.helper))]
                                          )
                                        ],
                                        1
                                      )
                                    })
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "section",
                                  { staticClass: "recruiting-section" },
                                  [
                                    _c(
                                      "h4",
                                      {
                                        staticClass: "recruiting-section__title"
                                      },
                                      [_vm._v("Notifications")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "recruiting-check-row" },
                                      [
                                        _c(
                                          "md-checkbox",
                                          {
                                            staticClass: "approval-request",
                                            model: {
                                              value:
                                                _vm.config.notifications
                                                  .requireApprovals,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.config.notifications,
                                                  "requireApprovals",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "config.notifications.requireApprovals"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                      Require approvals for jobs?\n                    "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          { staticClass: "recruiting-helper" },
                                          [
                                            _vm._v(
                                              "\n                      When checked, admin specifies recipient emails\n                      directly (not selected from the member pool).\n                    "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.config.notifications.requireApprovals
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "recruiting-field-row"
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "recruiting-field-row__label"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      Approval recipient emails:\n                    "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "md-field",
                                              { staticClass: "create-rule" },
                                              [
                                                _c("md-input", {
                                                  attrs: {
                                                    name: "approval_emails",
                                                    placeholder:
                                                      "email1@example.com, email2@example.com",
                                                    "md-autogrow": ""
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.config.notifications
                                                        .approvalEmails,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.config
                                                          .notifications,
                                                        "approvalEmails",
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                      )
                                                    },
                                                    expression:
                                                      "config.notifications.approvalEmails"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "p",
                                              {
                                                staticClass: "recruiting-helper"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      Comma-separated. Receives notification when a new\n                      job needs review.\n                    "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "recruiting-check-row" },
                                      [
                                        _c(
                                          "md-checkbox",
                                          {
                                            staticClass: "approval-request",
                                            model: {
                                              value:
                                                _vm.config.notifications
                                                  .jobReminder,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.config.notifications,
                                                  "jobReminder",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "config.notifications.jobReminder"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                      Job Reminder?\n                    "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          { staticClass: "recruiting-helper" },
                                          [
                                            _vm._v(
                                              "\n                      Sends a reminder to alums who haven't engaged\n                      with the opportunity after a configurable window.\n                    "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "section",
                                  { staticClass: "recruiting-section" },
                                  [
                                    _c(
                                      "h4",
                                      {
                                        staticClass: "recruiting-section__title"
                                      },
                                      [_vm._v("Matching Rules")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      {
                                        staticClass: "recruiting-section__desc"
                                      },
                                      [
                                        _vm._v(
                                          "\n                    Mirrors the existing Advice rules block.\n                  "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "recruiting-field-row" },
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "recruiting-field-row__label"
                                          },
                                          [
                                            _vm._v(
                                              "\n                      Minimum advisors that can be matched to a job:\n                    "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "md-field",
                                          { staticClass: "create-rule" },
                                          [
                                            _c("md-input", {
                                              directives: [
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required|min_value:1",
                                                  expression:
                                                    "'required|min_value:1'"
                                                }
                                              ],
                                              attrs: {
                                                name: "min_advisors_per_job",
                                                type: "number"
                                              },
                                              model: {
                                                value:
                                                  _vm.config.matching
                                                    .minAdvisorsPerJob,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.config.matching,
                                                    "minAdvisorsPerJob",
                                                    _vm._n($$v)
                                                  )
                                                },
                                                expression:
                                                  "config.matching.minAdvisorsPerJob"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          { staticClass: "recruiting-helper" },
                                          [_vm._v("Default: 25")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.errors.has(
                                                  "form-recruiting.min_advisors_per_job"
                                                ),
                                                expression:
                                                  "errors.has('form-recruiting.min_advisors_per_job')"
                                              }
                                            ],
                                            staticClass: "recruiting-error"
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.errors.first(
                                                    "form-recruiting.min_advisors_per_job"
                                                  )
                                                ) +
                                                "\n                    "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "recruiting-check-row" },
                                      [
                                        _c(
                                          "md-checkbox",
                                          {
                                            staticClass: "approval-request",
                                            model: {
                                              value:
                                                _vm.config.matching
                                                  .refillEnabled,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.config.matching,
                                                  "refillEnabled",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "config.matching.refillEnabled"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                      Refill\n                    "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          { staticClass: "recruiting-helper" },
                                          [
                                            _vm._v(
                                              "\n                      Top-up advisors when interest thresholds aren't met.\n                    "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "recruiting-field-row" },
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "recruiting-field-row__label"
                                          },
                                          [_vm._v("Interest Clicks:")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "md-field",
                                          { staticClass: "create-rule" },
                                          [
                                            _c("md-input", {
                                              directives: [
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required|min_value:0",
                                                  expression:
                                                    "'required|min_value:0'"
                                                }
                                              ],
                                              attrs: {
                                                name: "interest_clicks",
                                                type: "number"
                                              },
                                              model: {
                                                value:
                                                  _vm.config.matching
                                                    .interestClicks,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.config.matching,
                                                    "interestClicks",
                                                    _vm._n($$v)
                                                  )
                                                },
                                                expression:
                                                  "config.matching.interestClicks"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          { staticClass: "recruiting-helper" },
                                          [
                                            _vm._v(
                                              "\n                      Default: 5 — threshold of click engagement before\n                      triggering refill.\n                    "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.errors.has(
                                                  "form-recruiting.interest_clicks"
                                                ),
                                                expression:
                                                  "errors.has('form-recruiting.interest_clicks')"
                                              }
                                            ],
                                            staticClass: "recruiting-error"
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.errors.first(
                                                    "form-recruiting.interest_clicks"
                                                  )
                                                ) +
                                                "\n                    "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "recruiting-field-row" },
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "recruiting-field-row__label"
                                          },
                                          [_vm._v("Days to Refill:")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "md-field",
                                          { staticClass: "create-rule" },
                                          [
                                            _c("md-input", {
                                              directives: [
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required|min_value:1",
                                                  expression:
                                                    "'required|min_value:1'"
                                                }
                                              ],
                                              attrs: {
                                                name: "days_to_refill",
                                                type: "number"
                                              },
                                              model: {
                                                value:
                                                  _vm.config.matching
                                                    .daysToRefill,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.config.matching,
                                                    "daysToRefill",
                                                    _vm._n($$v)
                                                  )
                                                },
                                                expression:
                                                  "config.matching.daysToRefill"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          { staticClass: "recruiting-helper" },
                                          [_vm._v("Default: 3")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.errors.has(
                                                  "form-recruiting.days_to_refill"
                                                ),
                                                expression:
                                                  "errors.has('form-recruiting.days_to_refill')"
                                              }
                                            ],
                                            staticClass: "recruiting-error"
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.errors.first(
                                                    "form-recruiting.days_to_refill"
                                                  )
                                                ) +
                                                "\n                    "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "recruiting-field-row" },
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "recruiting-field-row__label"
                                          },
                                          [
                                            _vm._v(
                                              "\n                      Minimum advisors for refill:\n                    "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "md-field",
                                          { staticClass: "create-rule" },
                                          [
                                            _c("md-input", {
                                              directives: [
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required|min_value:1",
                                                  expression:
                                                    "'required|min_value:1'"
                                                }
                                              ],
                                              attrs: {
                                                name: "min_advisors_for_refill",
                                                type: "number"
                                              },
                                              model: {
                                                value:
                                                  _vm.config.matching
                                                    .minAdvisorsForRefill,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.config.matching,
                                                    "minAdvisorsForRefill",
                                                    _vm._n($$v)
                                                  )
                                                },
                                                expression:
                                                  "config.matching.minAdvisorsForRefill"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          { staticClass: "recruiting-helper" },
                                          [_vm._v("Default: 5")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.errors.has(
                                                  "form-recruiting.min_advisors_for_refill"
                                                ),
                                                expression:
                                                  "errors.has('form-recruiting.min_advisors_for_refill')"
                                              }
                                            ],
                                            staticClass: "recruiting-error"
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.errors.first(
                                                    "form-recruiting.min_advisors_for_refill"
                                                  )
                                                ) +
                                                "\n                    "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "recruiting-field-row" },
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "recruiting-field-row__label"
                                          },
                                          [_vm._v("Maximum advisors per job:")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "md-field",
                                          { staticClass: "create-rule" },
                                          [
                                            _c("md-input", {
                                              directives: [
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required|min_value:1",
                                                  expression:
                                                    "'required|min_value:1'"
                                                }
                                              ],
                                              attrs: {
                                                name: "max_advisors_per_job",
                                                type: "number"
                                              },
                                              model: {
                                                value:
                                                  _vm.config.matching
                                                    .maxAdvisorsPerJob,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.config.matching,
                                                    "maxAdvisorsPerJob",
                                                    _vm._n($$v)
                                                  )
                                                },
                                                expression:
                                                  "config.matching.maxAdvisorsPerJob"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          { staticClass: "recruiting-helper" },
                                          [_vm._v("Default: 100")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.errors.has(
                                                  "form-recruiting.max_advisors_per_job"
                                                ),
                                                expression:
                                                  "errors.has('form-recruiting.max_advisors_per_job')"
                                              }
                                            ],
                                            staticClass: "recruiting-error"
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.errors.first(
                                                    "form-recruiting.max_advisors_per_job"
                                                  )
                                                ) +
                                                "\n                    "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "section",
                                  { staticClass: "recruiting-section" },
                                  [
                                    _c(
                                      "h4",
                                      {
                                        staticClass: "recruiting-section__title"
                                      },
                                      [_vm._v("Patterns")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      {
                                        staticClass: "recruiting-section__desc"
                                      },
                                      [
                                        _vm._v(
                                          "\n                    Pattern sets gate which opportunities qualify for\n                    matching. Protopia defaults apply automatically;\n                    customer extensions are additive.\n                  "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "recruiting-pattern-buttons"
                                      },
                                      [
                                        _c(
                                          "md-button",
                                          {
                                            staticClass:
                                              "md-raised md-accent md-white-color capitalize",
                                            on: {
                                              click: function($event) {
                                                return _vm.openPatternView(
                                                  "library"
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                      Pattern Library\n                    "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "md-button",
                                          {
                                            staticClass:
                                              "md-raised md-accent md-white-color capitalize",
                                            on: {
                                              click: function($event) {
                                                return _vm.openPatternView(
                                                  "create"
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                      Create Pattern Set\n                    "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "md-button",
                                          {
                                            staticClass:
                                              "md-raised md-accent md-white-color capitalize",
                                            on: {
                                              click: function($event) {
                                                return _vm.openPatternView(
                                                  "test"
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                      Test Pattern Set\n                    "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "md-button",
                                          {
                                            staticClass:
                                              "md-raised md-accent md-white-color capitalize",
                                            on: {
                                              click: function($event) {
                                                return _vm.openPatternView(
                                                  "quarantine"
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                      Quarantine Review\n                    "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "md-button",
                            {
                              staticClass: "mt-20 md-raised md-round md-accent",
                              attrs: { type: "submit" }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.saveText) +
                                  "\n              "
                              )
                            ]
                          )
                        ],
                        2
                      )
                    ])
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d61becf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d61becf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CommunityRecruitingConfig.vue
// module id = null
// module chunks = 